/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_No_IdInputs */



/**
* | output |
* | --- |
* | "No VEKN ID" |
*
* @param {Vekn_No_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_no_id = /** @type {((inputs?: Vekn_No_IdInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_No_IdInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas de VEKN ID")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin ID VEKN")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sem VEKN ID")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun VEKN ID")
	return /** @type {LocalizedString} */ ("No VEKN ID")
});